import { render, staticRenderFns } from "./Toolbar3.vue?vue&type=template&id=169d169b&scoped=true&"
import script from "./Toolbar3.vue?vue&type=script&lang=js&"
export * from "./Toolbar3.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar3.vue?vue&type=style&index=0&id=169d169b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d169b",
  null
  
)

export default component.exports